import NotificationList from "./notification-list";

export default NotificationList;